// Import styles  
import './scss/main.scss'

// Import other scripts
import 'bootstrap'
import 'jquery-validation'
import 'jquery-validation-unobtrusive'

import './js/site'